export default "__VITE_ASSET__DiXFbeTz__"